import React, { useState } from 'react';
import AdminPanel from '../admin/AdminPannel';

const Ludo = () => {
  const [playerPositions, setPlayerPositions] = useState({
    red: [0, 0, 0, 0], // Positions of 4 red pawns (0-home, 1-52 board, >52 winning track)
    blue: [0, 0, 0, 0],
    green: [0, 0, 0, 0],
    yellow: [0, 0, 0, 0],
  });
  const [currentPlayer, setCurrentPlayer] = useState('red');
  const [diceRoll, setDiceRoll] = useState(0);
  const [message, setMessage] = useState('');

  const colors = ['red', 'blue', 'green', 'yellow'];

  const boardSquares = Array.from({ length: 52 }, (_, i) => i + 1);

  const winningTrackLength = 6;

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: 'sans-serif',
    },
    board: {
      display: 'grid',
      gridTemplateColumns: 'repeat(15, 1fr)',
      gridTemplateRows: 'repeat(15, 1fr)',
      width: '600px',
      height: '600px',
      border: '2px solid black',
    },
    square: {
      border: '1px solid #ccc',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '0.8em',
    },
    home: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    playerHome: (color) => ({
      width: '80%',
      height: '80%',
      border: `2px solid ${color}`,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'wrap',
    }),
    pawn: (color) => ({
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: color,
      border: '1px solid black',
      cursor: 'pointer',
    }),
    controls: {
      marginTop: '20px',
      display: 'flex',
      gap: '20px',
      alignItems: 'center',
    },
    dice: {
      border: '1px solid black',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '1.5em',
      width: '50px',
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    rollButton: {
      padding: '10px 20px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    message: {
      marginTop: '10px',
      fontWeight: 'bold',
    },
    winningTrack: (color) => ({
      backgroundColor: `rgba(${color === 'red' ? '255, 0, 0' : color === 'blue' ? '0, 0, 255' : color === 'green' ? '0, 255, 0' : '255, 255, 0'}, 0.2)`,
    }),
  };

  const renderBoard = () => (
    <div style={styles.board}>
      {/* Implementation of the Ludo board layout would go here. */}
      {/* This is a complex part and would require detailed logic for each cell. */}
      {/* For a simplified example, let's just render basic squares. */}
      {Array.from({ length: 225 }, (_, i) => (
        <div key={i} style={styles.square}>
          {/* You would conditionally render homes, tracks, etc. here */}
        </div>
      ))}

      {/* Example of Player Homes (Needs accurate positioning) */}
      <div style={{ ...styles.square, gridColumnStart: 2, gridColumnEnd: 5, gridRowStart: 2, gridRowEnd: 5, ...styles.home }}>
        <div style={styles.playerHome('red')}>
          {playerPositions.red.map((pos, index) => (
            <div key={`red-${index}`} style={styles.pawn('red')} onClick={() => handlePawnClick('red', index)} />
          ))}
        </div>
      </div>
      <div style={{ ...styles.square, gridColumnStart: 12, gridColumnEnd: 15, gridRowStart: 2, gridRowEnd: 5, ...styles.home }}>
        <div style={styles.playerHome('blue')}>
          {playerPositions.blue.map((pos, index) => (
            <div key={`blue-${index}`} style={styles.pawn('blue')} onClick={() => handlePawnClick('blue', index)} />
          ))}
        </div>
      </div>
      <div style={{ ...styles.square, gridColumnStart: 2, gridColumnEnd: 5, gridRowStart: 12, gridRowEnd: 15, ...styles.home }}>
        <div style={styles.playerHome('green')}>
          {playerPositions.green.map((pos, index) => (
            <div key={`green-${index}`} style={styles.pawn('green')} onClick={() => handlePawnClick('green', index)} />
          ))}
        </div>
      </div>
      <div style={{ ...styles.square, gridColumnStart: 12, gridColumnEnd: 15, gridRowStart: 12, gridRowEnd: 15, ...styles.home }}>
        <div style={styles.playerHome('yellow')}>
          {playerPositions.yellow.map((pos, index) => (
            <div key={`yellow-${index}`} style={styles.pawn('yellow')} onClick={() => handlePawnClick('yellow', index)} />
          ))}
        </div>
      </div>

      {/* You would also need to render the main track and winning tracks */}
      {/* This is a placeholder and needs to be fully implemented based on the Ludo board structure */}
    </div>
  );

  const rollDice = () => {
    const roll = Math.floor(Math.random() * 6) + 1;
    setDiceRoll(roll);
    setMessage(`${currentPlayer} rolled a ${roll}`);
  };

  const handlePawnClick = (player, pawnIndex) => {
    // Logic to move the pawn based on the dice roll
    if (diceRoll === 0 || currentPlayer !== player) {
      setMessage('Roll the dice first or it\'s not your turn.');
      return;
    }

    const newPositions = { ...playerPositions };
    const currentPosition = newPositions[player][pawnIndex];
    let nextPosition = currentPosition + diceRoll;

    // Basic movement logic (needs to be refined for the actual Ludo board)
    if (currentPosition === 0 && diceRoll === 6) {
      newPositions[player][pawnIndex] = 1; // Move out of home
    } else if (currentPosition > 0 && currentPosition < 53) {
      newPositions[player][pawnIndex] = nextPosition <= 52 ? nextPosition : nextPosition > 52 && currentPosition <= 52 ? 52 + (nextPosition - 52) : nextPosition;
    } else if (currentPosition >= 53 && currentPosition < 53 + winningTrackLength) {
        newPositions[player][pawnIndex] = nextPosition;
    }


    setPlayerPositions(newPositions);
    setDiceRoll(0); // Reset dice roll after moving
    switchPlayer();
  };

  const switchPlayer = () => {
    const currentIndex = colors.indexOf(currentPlayer);
    setCurrentPlayer(colors[(currentIndex + 1) % colors.length]);
    setMessage(`It's ${colors[(currentIndex + 1) % colors.length]}'s turn`);
  };

  return (
    <div style={styles.container}>
        <AdminPanel/>
      <h1>New Generation Ludo</h1>
      <div style={styles.message}>{message}</div>
      {renderBoard()}
      <div style={styles.controls}>
        <div style={styles.dice}>{diceRoll}</div>
        <button style={styles.rollButton} onClick={rollDice}>
          Roll Dice
        </button>
        <div>Current Player: <span style={{ color: currentPlayer, fontWeight: 'bold' }}>{currentPlayer}</span></div>
      </div>
    </div>
  );
};

export default Ludo;